import { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';
import useExperiments from '@alltrails/experiments/hooks/useExperiments';
import DismissableCallout from '@alltrails/layout/components/DismissableCallout/DismissableCallout';

type NewMapLayersCalloutProps = Pick<ComponentProps<typeof DismissableCallout>, 'anchor' | 'isOpen' | 'onDismiss'>;

const NewMapLayersCallout = ({ anchor, isOpen, onDismiss }: NewMapLayersCalloutProps) => {
  const isInFoliageExperiment = useExperiments()?.['web-disco-rm-fall-foliage']?.value === 'on';

  return (
    <DismissableCallout
      anchor={<div>{anchor}</div>} // Wrapping div needed due to how usePopover works with cloning the anchor
      title={<FormattedMessage defaultMessage="New!" />}
      body={
        isInFoliageExperiment ? (
          <FormattedMessage defaultMessage="Check out the new Fall foliage overlay!" />
        ) : (
          <FormattedMessage defaultMessage="Check out new map layers included in your membership" />
        )
      }
      placement="bottom-end"
      isOpen={isOpen}
      onDismiss={onDismiss}
    />
  );
};

export default NewMapLayersCallout;
